import * as THREE from 'three'
import { logoBtImageUrl } from '../../assets'
import { ThreeComponet } from './types'
import vertexShader from './glsl/titleObject.vs'
import fragmentShader from './glsl/titleObject.fs'

interface TitleObjectUniforms {
  time: THREE.IUniform<number>
  resolution: THREE.IUniform<THREE.Vector2>
  texture: THREE.IUniform<THREE.Texture | null>
  [uniform: string]: THREE.IUniform<any>
}

export default class TitleObject extends ThreeComponet<TitleObjectUniforms> {
  isLoaded

  constructor() {
    super({
      time: {
        // type: 'f',
        value: 0,
      },
      resolution: {
        // type: 'v2',
        value: new THREE.Vector2(),
      },
      texture: {
        // type: 't',
        value: null,
      },
    })
    this.isLoaded = false
  }

  loadTexture(callback?: () => void): void {
    const loader = new THREE.TextureLoader()
    loader.load(logoBtImageUrl, (texture) => {
      texture.magFilter = THREE.NearestFilter
      texture.minFilter = THREE.NearestFilter
      this.uniforms.texture.value = texture
      this.obj = this.createObj()
      this.isLoaded = true
      if (callback) callback()
    })
  }

  createObj(): THREE.Mesh {
    const mesh = new THREE.Mesh(
      new THREE.PlaneGeometry(256, 64, 40, 10),
      new THREE.RawShaderMaterial({
        uniforms: this.uniforms,
        vertexShader,
        fragmentShader,
        transparent: true,
      })
    )
    mesh.position.set(0, -50, 0)
    return mesh
  }

  render(time: number): void {
    if (!this.isLoaded) return
    this.uniforms.time.value += time
  }
}
